const deepClone = <T>(itemToClone: T): T => {
  if (typeof structuredClone === "function") {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/structuredClone
    return structuredClone(itemToClone);
  }

  return JSON.parse(JSON.stringify(itemToClone));
};

export { deepClone };
